module.exports = __webpack_public_path__ + "img/full-onboarding.97b7834b.svg";